/** Enum describing client device type */
export var DeviceType;
(function (DeviceType) {
    /** Desktop device */
    DeviceType["Desktop"] = "DESKTOP";
    /** Mobile device */
    DeviceType["Mobile"] = "MOBILE";
})(DeviceType || (DeviceType = {}));
/** Page language */
export var PageLanguage;
(function (PageLanguage) {
    /** German page language */
    PageLanguage["De"] = "DE";
    /** English page language */
    PageLanguage["En"] = "EN";
    /** French page language */
    PageLanguage["Fr"] = "FR";
    /** Unknown page language */
    PageLanguage["Unknown"] = "UNKNOWN";
})(PageLanguage || (PageLanguage = {}));
export var ImageResizingType;
(function (ImageResizingType) {
    ImageResizingType["Auto"] = "AUTO";
    ImageResizingType["Fill"] = "FILL";
    ImageResizingType["FillDown"] = "FILL_DOWN";
    ImageResizingType["Fit"] = "FIT";
    ImageResizingType["Force"] = "FORCE";
})(ImageResizingType || (ImageResizingType = {}));
/** Enum describing where link should be opened */
export var OpenLinkMethod;
(function (OpenLinkMethod) {
    /** Link should be opened in a new tab */
    OpenLinkMethod["NewTab"] = "NEW_TAB";
    /** Link should be opened in a new window */
    OpenLinkMethod["NewWindow"] = "NEW_WINDOW";
    /** Link should be opened in an overlay */
    OpenLinkMethod["Overlay"] = "OVERLAY";
    /** Link should be opened in the current tab */
    OpenLinkMethod["ThisTab"] = "THIS_TAB";
})(OpenLinkMethod || (OpenLinkMethod = {}));
export var PageType;
(function (PageType) {
    PageType["AgencyObject"] = "AGENCY_OBJECT";
    PageType["AgencyOverview"] = "AGENCY_OVERVIEW";
    PageType["B2BLogin"] = "B2B_LOGIN";
    PageType["BlogArticle"] = "BLOG_ARTICLE";
    PageType["BlogOverview"] = "BLOG_OVERVIEW";
    PageType["Bookmark"] = "BOOKMARK";
    PageType["CatalogOverview"] = "CATALOG_OVERVIEW";
    PageType["CombinedThemeGeo"] = "COMBINED_THEME_GEO";
    PageType["Contact"] = "CONTACT";
    PageType["EmailAdvertisingRevocation"] = "EMAIL_ADVERTISING_REVOCATION";
    PageType["EmailAdvertisingRevocationConfirmation"] = "EMAIL_ADVERTISING_REVOCATION_CONFIRMATION";
    PageType["FlightHome"] = "FLIGHT_HOME";
    PageType["FlightSrl"] = "FLIGHT_SRL";
    PageType["GeoChildrenOffers"] = "GEO_CHILDREN_OFFERS";
    PageType["GeoClimate"] = "GEO_CLIMATE";
    PageType["GeoFacts"] = "GEO_FACTS";
    PageType["GeoMap"] = "GEO_MAP";
    PageType["GeoObject"] = "GEO_OBJECT";
    PageType["GeoOverview"] = "GEO_OVERVIEW";
    PageType["GeoSrl"] = "GEO_SRL";
    PageType["HolidayFinderLanding"] = "HOLIDAY_FINDER_LANDING";
    PageType["HolidayFinderResults"] = "HOLIDAY_FINDER_RESULTS";
    PageType["HolidayFinderVoting"] = "HOLIDAY_FINDER_VOTING";
    PageType["Home"] = "HOME";
    PageType["MyaccountBookingDetails"] = "MYACCOUNT_BOOKING_DETAILS";
    PageType["MyaccountConfirmation"] = "MYACCOUNT_CONFIRMATION";
    PageType["MyaccountLogin"] = "MYACCOUNT_LOGIN";
    PageType["MyaccountMybookings"] = "MYACCOUNT_MYBOOKINGS";
    PageType["MyaccountMybookingsPast"] = "MYACCOUNT_MYBOOKINGS_PAST";
    PageType["MyaccountMybookingsUpcoming"] = "MYACCOUNT_MYBOOKINGS_UPCOMING";
    PageType["MyaccountMyhistory"] = "MYACCOUNT_MYHISTORY";
    PageType["MyaccountMyprofile"] = "MYACCOUNT_MYPROFILE";
    PageType["MyaccountOverview"] = "MYACCOUNT_OVERVIEW";
    PageType["MyaccountRegistration"] = "MYACCOUNT_REGISTRATION";
    PageType["MyaccountResetPassword"] = "MYACCOUNT_RESET_PASSWORD";
    PageType["NewsArticle"] = "NEWS_ARTICLE";
    PageType["NewsArticleOverview"] = "NEWS_ARTICLE_OVERVIEW";
    PageType["NewsletterConfirmation"] = "NEWSLETTER_CONFIRMATION";
    PageType["NewsletterFinalization"] = "NEWSLETTER_FINALIZATION";
    PageType["NewsletterSubscription"] = "NEWSLETTER_SUBSCRIPTION";
    PageType["NewsletterUnsubscription"] = "NEWSLETTER_UNSUBSCRIPTION";
    PageType["NewsletterUnsubscriptionFinalization"] = "NEWSLETTER_UNSUBSCRIPTION_FINALIZATION";
    PageType["Orl"] = "ORL";
    PageType["Page_404"] = "PAGE_404";
    PageType["Pdp"] = "PDP";
    PageType["PdpClimate"] = "PDP_CLIMATE";
    PageType["PdpDescription"] = "PDP_DESCRIPTION";
    PageType["PdpItinerary"] = "PDP_ITINERARY";
    PageType["PdpMap"] = "PDP_MAP";
    PageType["PdpRating"] = "PDP_RATING";
    PageType["PdpRegion"] = "PDP_REGION";
    PageType["PdpResort"] = "PDP_RESORT";
    PageType["PdpReviews"] = "PDP_REVIEWS";
    PageType["Srl"] = "SRL";
    PageType["Static"] = "STATIC";
    PageType["ThemeObject"] = "THEME_OBJECT";
    PageType["ThemeOverview"] = "THEME_OVERVIEW";
    PageType["ThemeSrl"] = "THEME_SRL";
    PageType["Wishlist"] = "WISHLIST";
    PageType["WishlistCompare"] = "WISHLIST_COMPARE";
    PageType["WishlistList"] = "WISHLIST_LIST";
    PageType["WishlistMap"] = "WISHLIST_MAP";
    PageType["WishlistOfferCompare"] = "WISHLIST_OFFER_COMPARE";
})(PageType || (PageType = {}));
export var AccessRestrictionStatus;
(function (AccessRestrictionStatus) {
    AccessRestrictionStatus["Expired"] = "EXPIRED";
    AccessRestrictionStatus["UnknownStatus"] = "UNKNOWN_STATUS";
    AccessRestrictionStatus["VflyStatus"] = "VFLY_STATUS";
})(AccessRestrictionStatus || (AccessRestrictionStatus = {}));
export var BookingStatus;
(function (BookingStatus) {
    BookingStatus["Booked"] = "BOOKED";
    BookingStatus["Cancelled"] = "CANCELLED";
    BookingStatus["Failed"] = "FAILED";
    BookingStatus["Pending"] = "PENDING";
    BookingStatus["Travelled"] = "TRAVELLED";
    BookingStatus["Unknown"] = "UNKNOWN";
})(BookingStatus || (BookingStatus = {}));
export var ProductClass;
(function (ProductClass) {
    ProductClass["Apartment"] = "APARTMENT";
    ProductClass["Cruise"] = "CRUISE";
    ProductClass["Hotel"] = "HOTEL";
    ProductClass["Roundtrip"] = "ROUNDTRIP";
})(ProductClass || (ProductClass = {}));
/** Travel type */
export var TravelType;
(function (TravelType) {
    /** Flight travel type */
    TravelType["Flight"] = "FLIGHT";
    /** Hotel only travel type */
    TravelType["Hotel"] = "HOTEL";
    /** Package travel type */
    TravelType["Package"] = "PACKAGE";
})(TravelType || (TravelType = {}));
export var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["Open"] = "OPEN";
    PaymentStatus["Paid"] = "PAID";
})(PaymentStatus || (PaymentStatus = {}));
export var AgencyBrand;
(function (AgencyBrand) {
    AgencyBrand["GlobusReisen"] = "GLOBUS_REISEN";
    AgencyBrand["Hotelplan"] = "HOTELPLAN";
    AgencyBrand["Sv"] = "SV";
    AgencyBrand["Tpt"] = "TPT";
    AgencyBrand["Travelhouse"] = "TRAVELHOUSE";
    AgencyBrand["Unspecified"] = "UNSPECIFIED";
})(AgencyBrand || (AgencyBrand = {}));
export var GeoType;
(function (GeoType) {
    GeoType["Continent"] = "CONTINENT";
    GeoType["Country"] = "COUNTRY";
    GeoType["CountryGroup"] = "COUNTRY_GROUP";
    GeoType["Destination"] = "DESTINATION";
    GeoType["Region"] = "REGION";
    GeoType["Resort"] = "RESORT";
})(GeoType || (GeoType = {}));
export var ProductType;
(function (ProductType) {
    /** Hotel only */
    ProductType["Hotel"] = "HOTEL";
    /** Package */
    ProductType["Package"] = "PACKAGE";
})(ProductType || (ProductType = {}));
export var Bd4TravelRecommendationStatus;
(function (Bd4TravelRecommendationStatus) {
    Bd4TravelRecommendationStatus["ApiTimeout"] = "API_TIMEOUT";
    Bd4TravelRecommendationStatus["NotAvailable"] = "NOT_AVAILABLE";
    Bd4TravelRecommendationStatus["Success"] = "SUCCESS";
    Bd4TravelRecommendationStatus["TooFewResultsFromApi"] = "TOO_FEW_RESULTS_FROM_API";
    Bd4TravelRecommendationStatus["TooFewResultsFromHub"] = "TOO_FEW_RESULTS_FROM_HUB";
})(Bd4TravelRecommendationStatus || (Bd4TravelRecommendationStatus = {}));
export var Salutation;
(function (Salutation) {
    Salutation["Mr"] = "MR";
    Salutation["Ms"] = "MS";
    Salutation["SalutationUnknown"] = "SALUTATION_UNKNOWN";
})(Salutation || (Salutation = {}));
export var FlightClass;
(function (FlightClass) {
    FlightClass["Business"] = "BUSINESS";
    FlightClass["Economy"] = "ECONOMY";
    FlightClass["First"] = "FIRST";
    FlightClass["PremiumEconomy"] = "PREMIUM_ECONOMY";
})(FlightClass || (FlightClass = {}));
export var FlightDirection;
(function (FlightDirection) {
    FlightDirection["FlightDirectionInbound"] = "FLIGHT_DIRECTION_INBOUND";
    FlightDirection["FlightDirectionOutbound"] = "FLIGHT_DIRECTION_OUTBOUND";
})(FlightDirection || (FlightDirection = {}));
export var AvailablePaymentAction;
(function (AvailablePaymentAction) {
    AvailablePaymentAction["PaymentActionChangePayment"] = "PAYMENT_ACTION_CHANGE_PAYMENT";
    AvailablePaymentAction["PaymentActionInitPayment"] = "PAYMENT_ACTION_INIT_PAYMENT";
    AvailablePaymentAction["PaymentActionNotAvailable"] = "PAYMENT_ACTION_NOT_AVAILABLE";
    AvailablePaymentAction["PaymentActionOffline"] = "PAYMENT_ACTION_OFFLINE";
})(AvailablePaymentAction || (AvailablePaymentAction = {}));
export var ProductStatus;
(function (ProductStatus) {
    ProductStatus["Requested"] = "REQUESTED";
    ProductStatus["Unknown"] = "UNKNOWN";
})(ProductStatus || (ProductStatus = {}));
export var ServiceStatus;
(function (ServiceStatus) {
    ServiceStatus["Available"] = "AVAILABLE";
    ServiceStatus["Confirmed"] = "CONFIRMED";
    ServiceStatus["Unknown"] = "UNKNOWN";
})(ServiceStatus || (ServiceStatus = {}));
export var Status;
(function (Status) {
    Status["Failure"] = "FAILURE";
    Status["Success"] = "SUCCESS";
})(Status || (Status = {}));
export var AuthMethodType;
(function (AuthMethodType) {
    AuthMethodType["AgentId"] = "AGENT_ID";
    AuthMethodType["EMail"] = "E_MAIL";
    AuthMethodType["Facebook"] = "FACEBOOK";
    AuthMethodType["Google"] = "GOOGLE";
    AuthMethodType["Phone"] = "PHONE";
})(AuthMethodType || (AuthMethodType = {}));
export var SubscriptionType;
(function (SubscriptionType) {
    SubscriptionType["Dw"] = "DW";
    SubscriptionType["Ns"] = "NS";
})(SubscriptionType || (SubscriptionType = {}));
export var MapSuggestionType;
(function (MapSuggestionType) {
    MapSuggestionType["City"] = "CITY";
    MapSuggestionType["Region"] = "REGION";
})(MapSuggestionType || (MapSuggestionType = {}));
export var SearchPeriodType;
(function (SearchPeriodType) {
    SearchPeriodType["Exact"] = "EXACT";
    SearchPeriodType["Flexible"] = "FLEXIBLE";
})(SearchPeriodType || (SearchPeriodType = {}));
export var ImagePlacement;
(function (ImagePlacement) {
    ImagePlacement["Center"] = "CENTER";
    ImagePlacement["Left"] = "LEFT";
    ImagePlacement["Right"] = "RIGHT";
})(ImagePlacement || (ImagePlacement = {}));
export var EmployeeImagePlacement;
(function (EmployeeImagePlacement) {
    EmployeeImagePlacement["Center"] = "CENTER";
    EmployeeImagePlacement["Left"] = "LEFT";
    EmployeeImagePlacement["Right"] = "RIGHT";
})(EmployeeImagePlacement || (EmployeeImagePlacement = {}));
export var BookmarkType;
(function (BookmarkType) {
    BookmarkType["Adventuretravel"] = "ADVENTURETRAVEL";
    BookmarkType["Geo"] = "GEO";
    BookmarkType["Hotel"] = "HOTEL";
    BookmarkType["Roundtrip"] = "ROUNDTRIP";
    BookmarkType["Theme"] = "THEME";
    BookmarkType["Undefined"] = "UNDEFINED";
})(BookmarkType || (BookmarkType = {}));
export var BoosterFrequency;
(function (BoosterFrequency) {
    BoosterFrequency["Infinite"] = "INFINITE";
    BoosterFrequency["Once"] = "ONCE";
    BoosterFrequency["Twice"] = "TWICE";
})(BoosterFrequency || (BoosterFrequency = {}));
/** Enum describes types of catalogs */
export var CatalogType;
(function (CatalogType) {
    /** Catalog */
    CatalogType["Catalogue"] = "CATALOGUE";
    /** Flyer */
    CatalogType["Flyer"] = "FLYER";
})(CatalogType || (CatalogType = {}));
export var ClimateChartType;
(function (ClimateChartType) {
    ClimateChartType["MaxTemperaturePerMonth"] = "MAX_TEMPERATURE_PER_MONTH";
    ClimateChartType["RainDaysPerMonth"] = "RAIN_DAYS_PER_MONTH";
    ClimateChartType["SunHoursPerMonth"] = "SUN_HOURS_PER_MONTH";
    ClimateChartType["WaterTemperaturePerMonth"] = "WATER_TEMPERATURE_PER_MONTH";
})(ClimateChartType || (ClimateChartType = {}));
export var TravelDestinationType;
(function (TravelDestinationType) {
    TravelDestinationType["Airport"] = "AIRPORT";
    TravelDestinationType["AirportGroup"] = "AIRPORT_GROUP";
    TravelDestinationType["Continent"] = "CONTINENT";
    TravelDestinationType["Country"] = "COUNTRY";
    TravelDestinationType["CountryGroup"] = "COUNTRY_GROUP";
    TravelDestinationType["Cruise"] = "CRUISE";
    TravelDestinationType["Destination"] = "DESTINATION";
    TravelDestinationType["Geo"] = "GEO";
    TravelDestinationType["GiataCode"] = "GIATA_CODE";
    TravelDestinationType["Hotel"] = "HOTEL";
    TravelDestinationType["MythosCode"] = "MYTHOS_CODE";
    TravelDestinationType["Region"] = "REGION";
    TravelDestinationType["Resort"] = "RESORT";
    TravelDestinationType["Roundtrip"] = "ROUNDTRIP";
    TravelDestinationType["Theme"] = "THEME";
})(TravelDestinationType || (TravelDestinationType = {}));
export var FlightType;
(function (FlightType) {
    FlightType["OneWay"] = "ONE_WAY";
    FlightType["OpenJaw"] = "OPEN_JAW";
    FlightType["Return"] = "RETURN";
})(FlightType || (FlightType = {}));
export var FlightCheckoutStatus;
(function (FlightCheckoutStatus) {
    FlightCheckoutStatus["FlightCheckoutOfferChanged"] = "FLIGHT_CHECKOUT_OFFER_CHANGED";
    FlightCheckoutStatus["FlightCheckoutSuccess"] = "FLIGHT_CHECKOUT_SUCCESS";
    FlightCheckoutStatus["FlightCheckoutUnavailable"] = "FLIGHT_CHECKOUT_UNAVAILABLE";
})(FlightCheckoutStatus || (FlightCheckoutStatus = {}));
export var FlightSortDirection;
(function (FlightSortDirection) {
    FlightSortDirection["Asc"] = "ASC";
    FlightSortDirection["Desc"] = "DESC";
})(FlightSortDirection || (FlightSortDirection = {}));
export var FlightSortField;
(function (FlightSortField) {
    FlightSortField["DepartureTime"] = "DEPARTURE_TIME";
    FlightSortField["Duration"] = "DURATION";
    FlightSortField["Price"] = "PRICE";
})(FlightSortField || (FlightSortField = {}));
export var SrlGroupSorting;
(function (SrlGroupSorting) {
    SrlGroupSorting["GroupAlphabetic"] = "GROUP_ALPHABETIC";
    SrlGroupSorting["GroupPrice"] = "GROUP_PRICE";
    SrlGroupSorting["GroupTopDestination"] = "GROUP_TOP_DESTINATION";
})(SrlGroupSorting || (SrlGroupSorting = {}));
export var SrlProductSorting;
(function (SrlProductSorting) {
    SrlProductSorting["ProductBd4TravelRecommendation"] = "PRODUCT_BD4TRAVEL_RECOMMENDATION";
    SrlProductSorting["ProductBestseller"] = "PRODUCT_BESTSELLER";
    SrlProductSorting["ProductDistanceToPoi"] = "PRODUCT_DISTANCE_TO_POI";
    SrlProductSorting["ProductPopularity"] = "PRODUCT_POPULARITY";
    SrlProductSorting["ProductPrice"] = "PRODUCT_PRICE";
    SrlProductSorting["ProductRating"] = "PRODUCT_RATING";
    SrlProductSorting["ProductTaRating"] = "PRODUCT_TA_RATING";
})(SrlProductSorting || (SrlProductSorting = {}));
export var MoreVisibleItemType;
(function (MoreVisibleItemType) {
    MoreVisibleItemType["MoreVisibleFromOffers"] = "MORE_VISIBLE_FROM_OFFERS";
    MoreVisibleItemType["MoreVisibleFromSearches"] = "MORE_VISIBLE_FROM_SEARCHES";
    MoreVisibleItemType["MoreVisibleFromWishlist"] = "MORE_VISIBLE_FROM_WISHLIST";
})(MoreVisibleItemType || (MoreVisibleItemType = {}));
export var StaticPageStatus;
(function (StaticPageStatus) {
    StaticPageStatus["Error"] = "ERROR";
    StaticPageStatus["PageDoesNotExist"] = "PAGE_DOES_NOT_EXIST";
    StaticPageStatus["Success"] = "SUCCESS";
    StaticPageStatus["UnacceptedLanguage"] = "UNACCEPTED_LANGUAGE";
})(StaticPageStatus || (StaticPageStatus = {}));
export var MaintenanceNotificationType;
(function (MaintenanceNotificationType) {
    MaintenanceNotificationType["Emergency"] = "EMERGENCY";
    MaintenanceNotificationType["Maintenance"] = "MAINTENANCE";
})(MaintenanceNotificationType || (MaintenanceNotificationType = {}));
export var MaintenanceNotificationShowMode;
(function (MaintenanceNotificationShowMode) {
    MaintenanceNotificationShowMode["Once"] = "ONCE";
    MaintenanceNotificationShowMode["OnceEvery_2Hours"] = "ONCE_EVERY_2_HOURS";
    MaintenanceNotificationShowMode["OnceEvery_24Hours"] = "ONCE_EVERY_24_HOURS";
})(MaintenanceNotificationShowMode || (MaintenanceNotificationShowMode = {}));
export var AlternativeRoom;
(function (AlternativeRoom) {
    AlternativeRoom["RoomAlternativeBoard"] = "ROOM_ALTERNATIVE_BOARD";
    AlternativeRoom["RoomAlternativeRoom"] = "ROOM_ALTERNATIVE_ROOM";
    AlternativeRoom["RoomAlternativeRoomAndBoard"] = "ROOM_ALTERNATIVE_ROOM_AND_BOARD";
})(AlternativeRoom || (AlternativeRoom = {}));
export var OrlCheckoutStatus;
(function (OrlCheckoutStatus) {
    OrlCheckoutStatus["CheckoutOfferChanged"] = "CHECKOUT_OFFER_CHANGED";
    OrlCheckoutStatus["CheckoutStatusNotSet"] = "CHECKOUT_STATUS_NOT_SET";
    OrlCheckoutStatus["CheckoutSuccess"] = "CHECKOUT_SUCCESS";
    OrlCheckoutStatus["CheckoutUnavailable"] = "CHECKOUT_UNAVAILABLE";
})(OrlCheckoutStatus || (OrlCheckoutStatus = {}));
export var OrlSortField;
(function (OrlSortField) {
    OrlSortField["DepartureAirport"] = "DEPARTURE_AIRPORT";
    OrlSortField["DepartureDate"] = "DEPARTURE_DATE";
    OrlSortField["Duration"] = "DURATION";
    OrlSortField["Price"] = "PRICE";
})(OrlSortField || (OrlSortField = {}));
export var OrlPartnerPricing;
(function (OrlPartnerPricing) {
    OrlPartnerPricing["PricePerRoomPerNight"] = "PRICE_PER_ROOM_PER_NIGHT";
})(OrlPartnerPricing || (OrlPartnerPricing = {}));
export var GroupOrlItemHeadingType;
(function (GroupOrlItemHeadingType) {
    GroupOrlItemHeadingType["Date"] = "DATE";
    GroupOrlItemHeadingType["Number"] = "NUMBER";
    GroupOrlItemHeadingType["Text"] = "TEXT";
})(GroupOrlItemHeadingType || (GroupOrlItemHeadingType = {}));
export var IconType;
(function (IconType) {
    IconType["External"] = "EXTERNAL";
    IconType["Internal"] = "INTERNAL";
})(IconType || (IconType = {}));
export var SearchTypeEnum;
(function (SearchTypeEnum) {
    SearchTypeEnum["Adventuretravel"] = "ADVENTURETRAVEL";
    SearchTypeEnum["AutosuggestNonProducts"] = "AUTOSUGGEST_NON_PRODUCTS";
    SearchTypeEnum["AutosuggestProducts"] = "AUTOSUGGEST_PRODUCTS";
    SearchTypeEnum["BlogArticle"] = "BLOG_ARTICLE";
    SearchTypeEnum["ExtraHotel"] = "EXTRA_HOTEL";
    SearchTypeEnum["Geo"] = "GEO";
    SearchTypeEnum["Hotel"] = "HOTEL";
    SearchTypeEnum["Roundtrip"] = "ROUNDTRIP";
    SearchTypeEnum["StaticPage"] = "STATIC_PAGE";
    SearchTypeEnum["Theme"] = "THEME";
})(SearchTypeEnum || (SearchTypeEnum = {}));
export var SrlPrimarySort;
(function (SrlPrimarySort) {
    SrlPrimarySort["Group"] = "GROUP";
    SrlPrimarySort["None"] = "NONE";
    SrlPrimarySort["Single"] = "SINGLE";
})(SrlPrimarySort || (SrlPrimarySort = {}));
export var WishlistProductItemType;
(function (WishlistProductItemType) {
    WishlistProductItemType["Available"] = "AVAILABLE";
    WishlistProductItemType["FlightAndPriceChanged"] = "FLIGHT_AND_PRICE_CHANGED";
    WishlistProductItemType["FlightChanged"] = "FLIGHT_CHANGED";
    WishlistProductItemType["NotAvailable"] = "NOT_AVAILABLE";
    WishlistProductItemType["PriceChanged"] = "PRICE_CHANGED";
})(WishlistProductItemType || (WishlistProductItemType = {}));
export var BookingCancellationCode;
(function (BookingCancellationCode) {
    BookingCancellationCode["BookingCancellationCodeError"] = "BOOKING_CANCELLATION_CODE_ERROR";
    BookingCancellationCode["BookingCancellationCodeErrorNotAuthorized"] = "BOOKING_CANCELLATION_CODE_ERROR_NOT_AUTHORIZED";
    BookingCancellationCode["BookingCancellationCodeOk"] = "BOOKING_CANCELLATION_CODE_OK";
    BookingCancellationCode["BookingCancellationCodeWaitingForConfirmation"] = "BOOKING_CANCELLATION_CODE_WAITING_FOR_CONFIRMATION";
})(BookingCancellationCode || (BookingCancellationCode = {}));
export var SubscriptionState;
(function (SubscriptionState) {
    SubscriptionState["Finalized"] = "FINALIZED";
    SubscriptionState["Pending"] = "PENDING";
})(SubscriptionState || (SubscriptionState = {}));
export var UserRegistrationCode;
(function (UserRegistrationCode) {
    UserRegistrationCode["UserRegistrationCodeConflict"] = "USER_REGISTRATION_CODE_CONFLICT";
    UserRegistrationCode["UserRegistrationCodeError"] = "USER_REGISTRATION_CODE_ERROR";
    UserRegistrationCode["UserRegistrationCodeOk"] = "USER_REGISTRATION_CODE_OK";
})(UserRegistrationCode || (UserRegistrationCode = {}));
export var NewsletterType;
(function (NewsletterType) {
    NewsletterType["DealOfTheWeek"] = "DEAL_OF_THE_WEEK";
    NewsletterType["Hotelplan"] = "HOTELPLAN";
    NewsletterType["MigrosFerien"] = "MIGROS_FERIEN";
    NewsletterType["TourismePourTous"] = "TOURISME_POUR_TOUS";
    NewsletterType["TourismePourTousHiking"] = "TOURISME_POUR_TOUS_HIKING";
    NewsletterType["TourismePourTousSports"] = "TOURISME_POUR_TOUS_SPORTS";
    NewsletterType["Travelhouse"] = "TRAVELHOUSE";
})(NewsletterType || (NewsletterType = {}));
export var TravelDocumentType;
(function (TravelDocumentType) {
    TravelDocumentType["CancelInvoice"] = "CANCEL_INVOICE";
    TravelDocumentType["Document"] = "DOCUMENT";
    TravelDocumentType["Invoice"] = "INVOICE";
})(TravelDocumentType || (TravelDocumentType = {}));
export var AgencyAppointmentCallbackTimeDayType;
(function (AgencyAppointmentCallbackTimeDayType) {
    AgencyAppointmentCallbackTimeDayType["Saturday"] = "SATURDAY";
    AgencyAppointmentCallbackTimeDayType["Weekday"] = "WEEKDAY";
})(AgencyAppointmentCallbackTimeDayType || (AgencyAppointmentCallbackTimeDayType = {}));
